var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBowHex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 77,
    viewBox: "0 0 69 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.80664,
    y: 69.7178,
    width: 19.6474,
    height: 6.5355,
    rx: 3.26775,
    fill: "#5E9DB2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.3872,
    y: 69.7178,
    width: 19.6474,
    height: 6.5355,
    rx: 3.26775,
    fill: "#5E9DB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66789 38.223C1.53209 36.2187 1.53209 33.7652 2.66789 31.7609L15.9457 8.33054C17.1093 6.2772 19.2871 5.00815 21.6472 5.00815H47.9927C50.3528 5.00815 52.5306 6.2772 53.6942 8.33054L66.972 31.7609C68.1078 33.7652 68.1078 36.2187 66.972 38.223L53.6942 61.6534C52.5306 63.7067 50.3528 64.9757 47.9927 64.9757H21.6472C19.2871 64.9757 17.1093 63.7067 15.9457 61.6534L2.66789 38.223Z",
    fill: "#62A8BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8242 42.7414C42.3833 42.7414 48.5112 36.4904 48.5112 28.7794C48.5112 21.0684 42.3833 14.8174 34.8242 14.8174C27.2651 14.8174 21.1372 21.0684 21.1372 28.7794C21.1372 36.4904 27.2651 42.7414 34.8242 42.7414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7804 34.9101C35.5717 34.9101 38.6452 31.8138 38.6452 27.9944C38.6452 24.1749 35.5717 21.0786 31.7804 21.0786C27.989 21.0786 24.9155 24.1749 24.9155 27.9944C24.9155 31.8138 27.989 34.9101 31.7804 34.9101Z",
    fill: "#570029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6055 49.3788C36.5745 50.5657 36.589 54.7633 33.6284 55.9758L23.4533 60.143C21.1174 61.0997 18.5576 59.3892 18.5489 56.8657L18.5204 48.6196C18.5116 46.0962 21.0595 44.3635 23.402 45.2999L33.6055 49.3788Z",
    fill: "#F9858E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9482 49.3788C32.9792 50.5657 32.9647 54.7633 35.9254 55.9758L46.1004 60.143C48.4363 61.0997 50.9961 59.3892 51.0048 56.8657L51.0334 48.6196C51.0421 46.0962 48.4942 44.3635 46.1518 45.2999L35.9482 49.3788Z",
    fill: "#F9858E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.8307,
    cy: 52.8629,
    rx: 3.77694,
    ry: 3.85267,
    fill: "#FFEEED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowHex);
export default __webpack_public_path__ + "static/media/bow-hex.50f1503a319037448f66a7393b825ee9.svg";
export { ForwardRef as ReactComponent };